import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import { CompaniesSummaryRecord } from 'src/models';

const companiesSummaryApiPath = 'reports/companies-summary';

export type CompaniesSummaryQueryParams = {
  start?: string;
  end?: string;
  companyId?: string;
};

export const getCompaniesSummary = async ({
  params,
}: {
  params?: CompaniesSummaryQueryParams;
}): Promise<AxiosResponse<CompaniesSummaryRecord[] & ApiError>> => {
  return instance
    .get<CompaniesSummaryRecord[]>(companiesSummaryApiPath, { params })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
